import { Injectable } from "@angular/core";
import { PlanUsuario } from "../models/PlanesUsuario/PlanUsuario";
import { Subject } from "rxjs";
import { Resumen } from "../models/PlanesUsuario/Resumen";
import { CertificacionPrecio } from "../models/PlanesUsuario/CertificacionPrecio";
import { SessionUser } from "../shared/models/sessionUser";
import { TokenStorageService } from "./token-storage.service";

@Injectable({
	providedIn: "root",
})
export class PagoUsuarioService {
	public user: SessionUser;
	constructor(private tokenService: TokenStorageService) {
		this.user = this.tokenService.getUser() as SessionUser;
	}

	private triggerCalculationsSource = new Subject<void>();
	triggerCalculations$ = this.triggerCalculationsSource.asObservable();

	triggerCalculations() {
		console.groupCollapsed('%ctriggerCalculations() invoked', 'color: teal; font-weight: bold;');
    console.trace();
    console.groupEnd();
		this.triggerCalculationsSource.next();
	}
}
